/* eslint-disable jsx-a11y/anchor-is-valid */

import { Link, useMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Toolbar.scss";

const Toolbar = () => {
  const { t } = useTranslation();
  const accountActive = [useMatch("/user"), useMatch("/user/update")].filter(e => e != null).length >= 1;
  const passwordActive = useMatch("/user/password");
  const paymentActive = useMatch("/user/payment");

  return (
    <>
    <div className='toolbar specific-account-toolbar' id='kt_toolbar' >
        <div
            id='kt_toolbar_container'
            className={'container-fluid d-flex flex-stack'}
        >
            <Link className="specific-account-back-link" to="/gis">
              <span className="specific-account-back-link__icon" aria-hidden="true">&larr;</span>
              <span className="specific-account-back-link__text">{t("account:tabs.back_to_map")}</span>
            </Link>
            <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x specific-account-tabs">
                <li className="nav-item">
                    <Link className={"nav-link " + (accountActive ? 'active' : '')} to="/user">
                      <span className="specific-account-tabs__label specific-account-tabs__label--full">
                        {t("account:tabs.account")}
                      </span>
                      <span className="specific-account-tabs__label specific-account-tabs__label--compact">
                        {t("account:tabs.account_short", { defaultValue: "Cuenta" })}
                      </span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className={"nav-link " + (passwordActive ? 'active' : '')} to="/user/password">
                      <span className="specific-account-tabs__label specific-account-tabs__label--full">
                        {t("account:tabs.password")}
                      </span>
                      <span className="specific-account-tabs__label specific-account-tabs__label--compact">
                        {t("account:tabs.password_short", { defaultValue: "Contraseña" })}
                      </span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className={"nav-link " + (paymentActive ? 'active' : '')} to="/user/payment">
                      <span className="specific-account-tabs__label specific-account-tabs__label--full">
                        {t("account:tabs.payments")}
                      </span>
                      <span className="specific-account-tabs__label specific-account-tabs__label--compact">
                        {t("account:tabs.payments_short", { defaultValue: "Plan" })}
                      </span>
                    </Link>
                </li>
            </ul>
        </div>
    </div>
    </>
  )
}

export default Toolbar;
